export const DATE_FNS_DATE_ONLY_FORMAT = "yyyy-MM-dd"

export const TIMEZONE = "America/New_York"